module.exports = __webpack_public_path__ + "45bd4219267500ae8910a4aef0d78253.pdf";